import * as React from "react";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../../components/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import ContentFraming from "./ContentFraming";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute authenticatedElement={<ContentFraming />} isPopup={true} />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;



